export default {"src":"/_next/static/media/buy-back.fdf580e8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};